export const titelOverrides = {
    color: 'white',
    fontWeight: '600',
    fontFamily: 'inter'
};

export const descriptionOverides = {
    color: 'rgba(255, 255, 255, 0.5)',
    fontWeight: '400',
    fontFamily: 'inter'
};
